import React from 'react'
import PropTypes from 'prop-types'
import { OutlinedButton, BarIcon, TableIcon } from './IconButton.styles'

/**
 * The Icon Button's component.
 */
const IconButton = props => {
  const { disabled, type, variant, margin, onClick, singleIcon } = props

  const BaseLinkButton = OutlinedButton

  return (
    <BaseLinkButton
      color="default"
      disabled={disabled}
      type={type}
      size="medium"
      fontSize="12px"
      margin={margin}
      variant={variant}
      width="initial"
      fontWeight="regular"
      className={singleIcon ? 'singleBtn' : null}
      tabIndex={0}
      onClick={onClick}
    >
      {type === 'toggleChart' ? <BarIcon /> : <TableIcon />}
    </BaseLinkButton>
  )
}

IconButton.defaultProps = {
  disabled: false,
  singleIcon: false,
  type: 'toggleChart',
  variant: 'text',
  onClick: () => undefined
}
IconButton.propTypes = {
  singleIcon: PropTypes.bool,
  type: PropTypes.oneOf(['toggleChart', 'toggleTable']),
  disabled: PropTypes.bool,
  margin: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  variant: PropTypes.oneOf(['outlined', 'text']),
  onClick: PropTypes.func.isRequired
}

export default IconButton
